export const MEDIA_BACKGROUND = 'BACKGROUND';

export const MEDIA_MESSAGE_BMW = 'MESSAGE_BMW';
export const MEDIA_MESSAGE_MINI = 'MESSAGE_MINI';

export const MEDIA_BANNER_BMW = 'BANNER_BMW';
export const MEDIA_BANNER_MINI = 'BANNER_MINI';



// WEBPACK FOOTER //
// ./src/components/communication/MediaType.js